import { Lock } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { WFPButton } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=org.wfp.farm2go&pcampaignid=web_share";

// Shown when an Aggregator mobile user tries to log in on the Web (wrong environment).
export const LoginForbiddenAdministrator = () => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted p-6 text-foreground">
      <Card className="w-full max-w-md text-center shadow-md">
        <CardHeader className="flex flex-col items-center gap-4">
          <span className="flex size-16 items-center justify-center rounded-full bg-blue-100 text-blue-600">
            <Lock className="size-8" aria-hidden="true" />
          </span>
          <CardTitle className="text-2xl">
            {t("loginForbidden.administratorNotAllowedHeading")}
          </CardTitle>
          <CardDescription className="text-base">
            {t("loginForbidden.administratorNotAllowedText")}
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col items-center gap-6">
          <a
            href={GOOGLE_PLAY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex rounded-md focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring"
          >
            <img
              src="/static/google-play.svg"
              alt={t("login.landing.googlePlayBadgeAlt")}
              className="h-12 w-auto"
              decoding="async"
            />
          </a>
          <WFPButton type="button" variant="link" onClick={() => history.push("/logout")}>
            {t("loginForbidden.loginPage")}
          </WFPButton>
        </CardContent>
      </Card>
    </div>
  );
};

export default LoginForbiddenAdministrator;
